import { render, staticRenderFns } from "./SupplierReceivables.vue?vue&type=template&id=5482e472&scoped=true&"
import script from "./SupplierReceivables.vue?vue&type=script&lang=js&"
export * from "./SupplierReceivables.vue?vue&type=script&lang=js&"
import style0 from "./SupplierReceivables.vue?vue&type=style&index=0&id=5482e472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5482e472",
  null
  
)

export default component.exports